namespace RedBullMOBILE360.BulkSMS {
    export class BulkSMSColumns {
        static columnsKey = 'BulkSMS.BulkSMS';
    }
}